import { ENVIRONMENTS, getEnv } from "@/types/env";

const env = getEnv(process.env.VITE_ENV);

export const ZENRIN_BASE_URL =
  env === ENVIRONMENTS.PROD
    ? "https://web.zmaps-api.com"
    : "https://test-web.zmaps-api.com";

/** Leaflet タイル取得失敗時などに使う透明 1x1 画像（data URL） */
export const EMPTY_PIXEL =
  "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=";

/**
 * 住居表示 / 登記地番の検索テキスト入力の文字数上限。
 *
 * 画面のテキスト入力欄（ChibanViewer の SearchBox `inputProps`）と
 * URL クエリパラメータの正規化（urlParams/schema.ts の `address`）の双方で
 * 同一の上限を共有し、入口の差異（ドリフト）を防ぐ。
 */
export const CHIBAN_SEARCH_MAX_LENGTH = 100;
